/* eslint-disable */
import {BaseInterfApi} from 'unityrpcjs/unityrpc.js'

import * as Table from "rpc/Table/Table"
import * as Form from "rpc/Form/Form"
import * as Comm from "rpc/Comm/Comm"
export var TABLE_SPEC_StoreBill = "StoreBill";
export var TABLE_SPEC_StoreBillSku = "StoreBillSku";
export var TABLE_SPEC_StoreBillSkuLog = "StoreBillSkuLog";
export var TABLE_SPEC_SkuBatchCode = "SkuBatchCode";
export var TABLE_SPEC_StoreSku = "StoreSku";
export var TABLE_SPEC_Inventory = "Inventory";
export var TABLE_SPEC_InventoryCheck = "InventoryCheck";
export var TABLE_SPEC_InventoryCheckSku = "InventoryCheckSku";
export var TABLE_SPEC_StoreOrder = "StoreOrder";
export var TABLE_SPEC_StoreBuyOrder = "StoreBuyOrder";
export var TABLE_SPEC_BuyerReturnOrder = "BuyerReturnOrder";
export var TABLE_SPEC_SellerReturnOrder = "SellerReturnOrder";
export var TABLE_SPEC_StoreBillDraft = "StoreBillDraft";
export var FORM_SPEC_StoreBill = "StoreBill";
export var FORM_SPEC_StoreBill_out_store = "StoreBill_out_store";
export var FORM_SPEC_StoreBill_in_store = "StoreBill_in_store";
export var FORM_SPEC_StoreBill_out_sell = "StoreBill_out_sell";
export var FORM_SPEC_StoreBill_in_buy = "StoreBill_in_buy";
export var FORM_SPEC_StoreBill_assy = "StoreBill_assy";
export var FORM_SPEC_StoreBill_out_buy_return = "StoreBill_out_buy_return";
export var FORM_SPEC_StoreBill_in_sell_return = "StoreBill_in_sell_return";
export var FORM_SPEC_StoreBill_trans = "StoreBill_trans";
export var FORM_SPEC_StoreBill_loss = "StoreBill_loss";
export var FORM_SPEC_StoreBill_overflow = "StoreBill_overflow";
export var FORM_SPEC_SkuBatchCode = "SkuBatchCode";
export var FORM_SPEC_StoreBill_adjust_price = "StoreBill_adjust_price";
export var FORM_SPEC_InventoryCheck = "InventoryCheck";
export var FORM_SPEC_InventoryCheckFile = "InventoryCheckFile";
export var INVENTORY_CHECK_CHECKED = "checked";
export var STATUS_WAIT_SUBMIT = "wait_submit";
export var STATUS_WAIT_AUDIT = "wait_audit";
export var STATUS_AUDITED = "audited";
export var STATUS_UNAUDIT = "unaudit";
export var STATUS_RETURNED = "returned";

export class StoreBillSpec {
    constructor() {
        this.formSpec = new Form.FormSpec();  // 0 require
        this.tableSpec = new Table.TableSpec();  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

StoreBillSpec.__json_class__ = 'MisStore.StoreBillSpec'

export class StoreBillSpec_out_sell {
    constructor() {
        this.formSpec = new Form.FormSpec();  // 0 require
        this.tableSpec = new Table.TableSpec();  // 1 require
        this.costTableSpec = new Table.TableSpec();  // 2 require
        this.tableQueryResult = new Table.TableQueryResult();  // 3 require
        this.costTableQueryResult = new Table.TableQueryResult();  // 4 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

StoreBillSpec_out_sell.__json_class__ = 'MisStore.StoreBillSpec_out_sell'

export class StoreBillSpecData_out_sell {
    constructor() {
        this.formDatas = {};  // 0 require
        this.tableRecords = [];  // 1 require
        this.costTableRecords = [];  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

StoreBillSpecData_out_sell.__json_class__ = 'MisStore.StoreBillSpecData_out_sell'

export class InventorySkuInfo {
    constructor() {
        this.checkid = 0;  // 0 require
        this.skuid = 0;  // 1 require
        this.count = 0;  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

InventorySkuInfo.__json_class__ = 'MisStore.InventorySkuInfo'

export class StoreSku {
    constructor() {
        this.skuid = 0;  // 0 require
        this.name = "";  // 1 require
        this.producePlace = "";  // 2 require
        this.propSpec = "";  // 3 require
        this.productionDate = null;  // 4 require
        this.batchCode = "";  // 5 require
        this.unitName = "";  // 6 require
        this.count = 0;  // 7 require
        this.note = "";  // 8 require
        this.weight = 0;  // 9 require
        this.totalSendPrice = 0;  // 10 optional
        this.sendPrice = 0;  // 11 optional
        this.averageCost = 0;  // 12 require
        this.totalCost = 0;  // 13 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

StoreSku.__json_class__ = 'MisStore.StoreSku'

export class CompanyInfo {
    constructor() {
        this.companyid = 0;  // 0 require
        this.name = "";  // 1 require
        this.address = "";  // 2 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

CompanyInfo.__json_class__ = 'MisStore.CompanyInfo'

export class StoreBillInfo {
    constructor() {
        this.storebillid = 0;  // 0 require
        this.companyInfo = new CompanyInfo();  // 1 require
        this.type = "";  // 2 require
        this.storeBillCode = "";  // 3 require
        this.customName = "";  // 4 require
        this.storeName = "";  // 5 require
        this.handleUserName = "";  // 6 require
        this.summary = "";  // 7 require
        this.note = "";  // 8 require
        this.status = "";  // 9 require
        this.relative_id = "";  // 10 require
        this.deliveryUserName = "";  // 11 require
        this.create_time = null;  // 12 require
        this.storeSkus = [];  // 13 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

StoreBillInfo.__json_class__ = 'MisStore.StoreBillInfo'

export class MisStoreInterfApi extends BaseInterfApi {
    constructor(baseUrl, moduleName='MisStore',
            interfName='MisStoreInterf', token='anonymous', ...args) {
        super(baseUrl, moduleName, interfName, token, ...args)
    }


    getStoreBillSpec(specName, context) {
        let params = {
            specName: specName,
            };
        let req = this.createRequest('getStoreBillSpec', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getStoreBillSpec'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    putStoreBill_out_sell(uniqueKey,data, context) {
        let params = {
            uniqueKey: uniqueKey,
            data: data,
            };
        let req = this.createRequest('putStoreBill_out_sell', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('putStoreBill_out_sell'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getStoreBill_out_sell(uniqueKey, context) {
        let params = {
            uniqueKey: uniqueKey,
            };
        let req = this.createRequest('getStoreBill_out_sell', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getStoreBill_out_sell'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    submitInventorySku(info, context) {
        let params = {
            info: info,
            };
        let req = this.createRequest('submitInventorySku', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('submitInventorySku'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    finishInventoryCheck(checkid, context) {
        let params = {
            checkid: checkid,
            };
        let req = this.createRequest('finishInventoryCheck', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('finishInventoryCheck'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

    getStoreSkuInfoList(storebillid, context) {
        let params = {
            storebillid: storebillid,
            };
        let req = this.createRequest('getStoreSkuInfoList', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getStoreSkuInfoList'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/apis/rpc/MisStore/MisStore.js